// Function to set a cookie with a specific expiry time
function setCookie(name, value, minutes) {
  const date = new Date();
  date.setTime(date.getTime() + (minutes * 60 * 1000));
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

// Function to get a cookie value by name
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

// Function to initialize or reinitialize the timer
function initializeTimer() {
  const DURATION = 8 * 60 * 1000; 
  const timerElement = document.getElementById('cstm-cart-timer');
  const countdownElement = document.getElementById('countdown');

  // Check if an expiry time is already stored in cookies
  let expiryTime = getCookie('timerExpiry');

  // If no expiry time is set, return (don't show the timer)
  if (timerElement && !expiryTime) {
    timerElement.style.display = 'none';
    return;
  }

  expiryTime = parseInt(expiryTime, 10);

  // Update the countdown every second
  const interval = setInterval(() => {
    const currentTime = Date.now();
    const timeLeft = expiryTime - currentTime;

    // If time is up, hide the timer and clear the interval
    if (timerElement){
      if (timeLeft <= 0) {
        timerElement.style.display = 'none';
        clearInterval(interval);
        document.cookie = "timerExpiry=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      } else {
        timerElement.style.display = 'block';
  
        // Calculate minutes and seconds remaining
        const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);
  
        // Display remaining time in MM:SS format
        countdownElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
    }
  }, 1000);
}

document.addEventListener('ajaxProduct:added', function (evt) {
  const DURATION = 8 * 60 * 1000;
  const expiryTime = Date.now() + DURATION;

  setCookie('timerExpiry', expiryTime, 8);

  initializeTimer();
});

document.addEventListener('DOMContentLoaded', function () {
  initializeTimer();
});

$(document).ready(function () {
    const COOKIE_NAME = "bfTimer";
    const RESET_HOUR = 0; // European midnight (UTC)

    function getEuropeanMidnight() {
        const now = new Date();
        const midnight = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), RESET_HOUR, 0, 0));
        if (now.getUTCHours() >= RESET_HOUR) {
            // If it's past midnight in UTC, calculate for the next day
            midnight.setUTCDate(midnight.getUTCDate() + 1);
        }
        return midnight;
    }

    function getRemainingTime() {
        const now = new Date();
        const midnight = getEuropeanMidnight();
        const remaining = midnight - now; // Difference in milliseconds
        return {
            total: remaining,
            hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((remaining / (1000 * 60)) % 60),
            seconds: Math.floor((remaining / 1000) % 60)
        };
    }

    function setCookie(name, value, expires) {
        document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (let i = 0; i < cookies.length; i++) {
            const [key, value] = cookies[i].split("=");
            if (key === name) return value;
        }
        return null;
    }

    function startTimer() {
        const timerElement = $("#bf-sale-timer");
        const now = new Date();
        const midnight = getEuropeanMidnight();

        let initialRemaining = getRemainingTime().total;

        // Check if a cookie exists
        const savedTime = getCookie(COOKIE_NAME);
        if (savedTime) {
            const savedRemaining = parseInt(savedTime, 10);
            initialRemaining = Math.min(savedRemaining, initialRemaining);
        }

        // Save the initial remaining time in a cookie
        const cookieExpiry = new Date(midnight.getTime());
        setCookie(COOKIE_NAME, initialRemaining + now.getTime(), cookieExpiry);

        function updateTimer() {
            const remainingTime = getRemainingTime();
            if (remainingTime.total <= 0) {
                timerElement.text("00:00:00");
                return;
            }

            const hours = String(remainingTime.hours).padStart(2, "0");
            const minutes = String(remainingTime.minutes).padStart(2, "0");
            const seconds = String(remainingTime.seconds).padStart(2, "0");

            timerElement.text(`${hours}:${minutes}:${seconds}`);

            // Update the cookie with the latest time left
            const currentRemaining = remainingTime.total + new Date().getTime();
            setCookie(COOKIE_NAME, currentRemaining, cookieExpiry);
        }

        updateTimer();
        setInterval(updateTimer, 1000); // Update every second
    }

    startTimer();
});

